'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./index.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Stage = function Stage(_ref) {
    var children = _ref.children,
        className = _ref.className,
        maxSize = _ref.maxSize;

    var compClassNames = (0, _classnames2.default)('stage-comp', className, maxSize);
    return _react2.default.createElement(
        'div',
        { className: compClassNames },
        children
    );
};

Stage.propTypes = {
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    maxSize: _propTypes2.default.oneOf(['unlimited', 'small', 'medium', 'large'])
};
Stage.defaultProps = {
    maxSize: 'medium'
};

exports.default = Stage;
//# sourceMappingURL=index.js.map